// ©2024 Austin App House. All rights reserved.
import React from 'react';
import { connect } from 'react-redux';
import ClientFilterModal from './ClientDashboardWOFiltersModal';
import ContractorFilterModal from './ContractorDashboardWOFiltersModal';
import AdminDashboardWOFiltersModal from './AdminDashboardWOFiltersModal';

const FiltersModal = ({ auth, isOpen }) => {
  if (!isOpen) {
    return null;
  }

  switch (auth.user.userType) {
    case 'contractor':
      return <ContractorFilterModal />;
    case 'client':
      return <ClientFilterModal />;
    case 'superAdmin':
      return <AdminDashboardWOFiltersModal />;
    default:
      return null;
  }
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  isOpen: state.modalState.filtersModal.isOpen,
});

export default connect(mapStateToProps)(FiltersModal);
